import { useEffect, useRef } from 'react'

export default function useIsMountedRef(): { readonly isMounted: boolean } {
    const mountedRef = useRef(false)

    useEffect(() => {
        mountedRef.current = true
        return () => {
            mountedRef.current = false
        }
    }, [])

    return { isMounted: mountedRef.current }
}
